<label
  *ngIf="item"
  class="checkbox-item">
  <input
    (change)="checkChange(item)"
    [(ngModel)]="item.state"
    type="checkbox"
    class="checkbox-item__input">
  <span class="checkbox-item__icon"></span>
</label>
